import { deepEqual } from '@helpers/utils/equal/deepEqual';

const isKGColumn = (field: string): boolean =>
  field.startsWith('country_exposure.') || field.startsWith('theme_exposure.');

// Helper to normalize KG column field names by removing the ID part
// e.g., "country_exposure.5cd0efec.company.rank" -> "country_exposure.*.company.rank"
export const removeIdFromKgFilterName = (field: string): string => {
  if (
    field.startsWith('country_exposure.') ||
    field.startsWith('theme_exposure.')
  ) {
    const parts = field.split('.');

    if (parts.length >= 3) {
      return [parts[0], '*', ...parts.slice(2)].join('.');
    }
  }

  return field;
};

const separateColumns = (order: string[]) => {
  const regular: string[] = [];
  const kg: string[] = [];
  order.forEach(field => {
    if (isKGColumn(field)) {
      kg.push(field);
    } else {
      regular.push(field);
    }
  });
  return { regular, kg };
};

export const compareColumnsForKG = (
  savedColumns: string[],
  currentColumns: string[]
): boolean => {
  const savedCols = separateColumns(savedColumns);
  const currentCols = separateColumns(currentColumns);

  if (!deepEqual(savedCols.regular, currentCols.regular)) {
    return false;
  }

  return true;
};
